import {Button} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {getAppIntentUrlForDevices} from '../../AppRedirect/helpers';
import {DEVICE_PARAM_TYPE} from '../../Checkout/constants';

export const NewsletterSignupAppIntent: React.FC<{
  cta: string;
  device: DEVICE_PARAM_TYPE;
}> = ({cta, device}) => {
  const onNewsletterSignupButtonClick = () => {
    const appIntent = getAppIntentUrlForDevices({
      device,
      intent: 'newsletter/signup',
      searchParams: location.search,
    });

    window.location.href = appIntent;
  };

  return (
    <Container>
      <Cta disableShadow onClick={onNewsletterSignupButtonClick}>
        {cta}
      </Cta>
    </Container>
  );
};

const Container = styled.div`
  padding: 16px 0 24px 0;
`;

const Cta = styled(Button)`
  width: 100%;
`;
